import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user-details/user-table`,
        component: React.lazy(() => import('views/app-views/user_details/user_table')),
    },
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user-details/delete-user-table`,
        component: React.lazy(() => import('views/app-views/user_details/delete_user_table')),
    },
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user-details/account-band`,
        component: React.lazy(() => import('views/app-views/user_details/account_band')),
    },
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user-details/add-user`,
        component: React.lazy(() => import('views/app-views/user_details/adduser')),
    },
    {
        key: 'dep_and_cat.default',
        path: `${APP_PREFIX_PATH}/dep-and-cat/department`,
        component: React.lazy(() => import('views/app-views/dep_and_cat/department')),
    },
    {
        key: 'dep_and_cat.default',
        path: `${APP_PREFIX_PATH}/dep-and-cat/categoies`,
        component: React.lazy(() => import('views/app-views/dep_and_cat/categoies')),
    },
    {
        key: 'contact-us.default',
        path: `${APP_PREFIX_PATH}/contact-us/contact-us`,
        component: React.lazy(() => import('views/app-views/contact_us')),
    },
]